<template>
  <div>

    <el-row :gutter="20" style="border: 1px solid #e2e7ed;margin-top: 20px;margin-bottom: 20px">
      <el-col align="right" style="padding: 20px">

        <el-button type="primary" @click="addProductService()"
                   :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                   v-if="requestForm.cat_acquisition_type_id && disabledAdd">
          Agregar bien o servicio
        </el-button>

      </el-col>
      <el-col>
        <el-table
            :data="requestForm.articles.filter(up => !up.isHidden)"
            size="small" style="width: 100%">
          <el-table-column type="index" lable="#" align="center"/>
          <el-table-column label="Productos bienes o servicios" align="center">
            <el-table-column
                align="center"
                label="Bien o Servicio"
                min-width="180">
              <template slot-scope="scope">
                <el-select
                    style="width:100%"
                    v-model="scope.row.article_id"
                    filterable
                    :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                    placeholder="Seleccionar">
                  <el-option
                      v-for="(item,key5) in filterArticle(catalogs.catProductsOrServicesArticles,requestForm.cat_acquisition_type_id,requestForm.product_or_service_id)"
                      :key="(scope.$index+1)+'_'+(key5+1)+'_article'"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>

                <el-form-item
                    label="Describir"
                    :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }"
                    v-if="(
										scope.row.article_id == 7 || scope.row.article_id == 23 || scope.row.article_id == 32 ||
										scope.row.article_id == 36 || scope.row.article_id == 40 || scope.row.article_id == 45 || scope.row.article_id == 54
										)">
                  <el-input v-model="scope.row.describeAnotherName"
                            type="textarea"
                            style="word-break: break-word"
                            resize="none"
                            :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                            :autosize="{ minRows: 3, maxRows: 4}"
                            placeholder="Describir Otro">
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Cantidad"
                min-width="200">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.amount"
                                 :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                                 style="width: 70%;"
                                 :precision="0"
                                 :step="1"
                                 :min="0"
                                 placeholder="Cantidad">
                </el-input-number>
              </template>
            </el-table-column>
            <el-table-column
                width="650"
                label="Características/Especificaciones" >
              <template slot-scope="scope">
                <el-row>
                  <el-col>
                    <label class="el-form--label-top">Características Generales</label>
                    <br>
                    <el-button
                        type="text"
                        style="font-size: 10px"
                        v-clipboard:copy="scope.row.particularDescription"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                    >
                      Copiar <i class="fas fa-copy"/>
                    </el-button>
                    <el-input v-model="scope.row.particularDescription"
                              type="textarea"
                              resize="none"
                              style="word-break: break-word; text-align: justify!important;"
                              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                              :autosize="{ minRows: 3, maxRows: 6}"
                              placeholder="Describir Características Generales">
                    </el-input>
                    <span class="count-character">
                        			max	1000/{{ countCharacter(scope.row.particularDescription) }}
                    			</span>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <label class="el-form--label-top">Especificaciones Técnicas</label>
                    <br>
                    <el-button
                        type="text"
                        style="font-size: 10px"
                        v-clipboard:copy="scope.row.technicalDescription"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError"
                    >
                      Copiar <i class="fas fa-copy"/>
                    </el-button>
                    <el-input v-model="scope.row.technicalDescription"
                              type="textarea"
                              resize="none"
                              style="word-break: break-word;text-align: justify!important;"
                              :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                              :autosize="{ minRows: 3, maxRows: 6}"
                              placeholder="Describir Especificaciones Técnicas">
                    </el-input>
                    <span class="count-character">
									max	1000/{{ countCharacter(scope.row.technicalDescription) }}
                    			</span>
                  </el-col>
                </el-row>
              </template>
            </el-table-column>
            <el-table-column
                align="center"
                label="Representaciones"
                min-width="180">
              <template slot-scope="scope">
                <el-select
                    style="width:100%"
                    v-model="scope.row.office_ids"
                    filterable
                    multiple
                    :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                    placeholder="Seleccionar">
                  <el-option
                      v-for="(item,key6) in filterSelectedOffice(catalogs.catOffice, requestForm.office_ids)"
                      :key="key6"
                      :label="item.representation_name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
                fixed="right"
                align="center"
                label="Acciones"
                min-width="180">
              <template slot-scope="scope">
                <div style="padding: 20px">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      content="Eliminar"
                      v-if="requestForm.cat_acquisition_type_id"
                      placement="top-end">
                    <el-button
                        :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                        size="small"
                        type="danger"
                        @click="removeProduct(scope.row)">
                      <i class="fas fa-trash"></i>
                    </el-button>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>


    <el-dialog
        title="Articulos"
        :visible.sync="showModal"
        width="80%">

      <el-row :gutter="20">
        <el-form ref="formModal" :model="formModal" label-width="120px" label-position="top"
                 @submit.native.prevent>
          <el-col>
            <el-form-item
                label="Artículos"

                prop="article_id"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }">

              <el-select
                  style="width:100%"
                  v-model="formModal.article_id"
                  filterable
                  :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                  placeholder="Seleccionar">
                <el-option
                    v-for="(item,key) in filterArticle(catalogs.catProductsOrServicesArticles,requestForm.cat_acquisition_type_id,requestForm.product_or_service_id)"
                    :key="(key+1)+'_article'"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item
                prop="describeAnotherName"
                label="Describir"
                :rules="{ required: true, message: 'Este campo es obligatorio', trigger: ['blur','change']  }"
                v-if="(
										formModal.article_id == 7 || formModal.article_id == 23 || formModal.article_id == 32 ||
										formModal.article_id == 36 || formModal.article_id == 40 || formModal.article_id == 45 || formModal.article_id == 54
										)">
              <!--requestForm.cat_acquisition_type_id == 2 && -->
              <el-input v-model="formModal.describeAnotherName"
                        type="textarea"
                        resize="none"
                        :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                        :autosize="{ minRows: 3, maxRows: 4}"
                        placeholder="Describir Otro">
              </el-input>
            </el-form-item>
          </el-col>

          <el-col>

            <el-form-item
                label="Cantidad">
              <el-input-number v-model="formModal.amount"
                               :precision="0"
                               :step="1"
                               :min="0"
                               :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                               placeholder="Cantidad">
              </el-input-number>
            </el-form-item>
          </el-col>
          <el-col>

            <el-form-item
                label="Representaciones">
              <el-select
                  style="width:100%"
                  v-model="formModal.office_ids"
                  filterable
                  size="mini"
                  multiple
                  :disabled="onlyRead || requestForm.last_log.cat_acquisition_status_id >= 51 && requestForm.unlock == 1"
                  placeholder="Seleccionar">
                <el-option
                    v-for="(item,key) in filterSelectedOffice(catalogs.catOffice, requestForm.office_ids)"
                    :key="key+'_article'"
                    :label="item.representation_name"
                    :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>


          </el-col>
        </el-form>
      </el-row>
      <span slot="footer" class="dialog-footer">
					<el-button size="small" @click="showModal = false"> Cancelar</el-button>
					<el-button size="small" type="success" @click="saveModal()">Aceptar</el-button>
			</span>
    </el-dialog>


  </div>
</template>

<script>
import {mapState, mapGetters, mapActions, mapMutations} from "vuex";
import {Notification} from "element-ui";

export default {
  props: {
    disabledAdd: {type: Boolean},
    disbaledField: {type: Boolean},
  },
  data() {
    return {
      showModal: false,
      formModal: {
        index: null,
        article_id: null,
        describeAnotherName: null,
        amount: null,
        office_ids: [],
      }
    }
  },
  computed: {
    ...mapGetters("form", {
      requestForm: "requestForm",
      catalogs: "catalogs",
      onlyRead: "onlyRead"
    }),
  },
  methods: {

    ...mapMutations('form', {
      addProductService: "addProductService",
      removeStoreProductService: "removeProductService",
      restartCalculation: "restartCalculation"
    }),

    editArticle(row) {
      let index = this.requestForm.articles.indexOf(row);
      let rowTmp = Object.assign({}, row);


      //reset
      this.formModal = {
        index: null,
        article_id: null,
        describeAnotherName: null,
        amount: null,
        office_ids: [],
      };
      this.showModal = true;
      setTimeout(() => {
        this.$refs['formModal'].resetFields();

        this.formModal = {
          index: index,
          article_id: rowTmp.article_id,
          describeAnotherName: rowTmp.describeAnotherName,
          amount: rowTmp.amount,
          office_ids: rowTmp.office_ids,
        };

      }, 500);


    },
    saveModal() {
      this.$refs['formModal'].validate((valid) => {
        if (valid) {
          this.requestForm.articles[this.formModal.index].article_id = this.formModal.article_id;
          this.requestForm.articles[this.formModal.index].describeAnotherName = this.formModal.describeAnotherName;
          this.requestForm.articles[this.formModal.index].amount = this.formModal.amount;
          this.requestForm.articles[this.formModal.index].office_ids = this.formModal.office_ids;


          this.formModal = {
            index: null,
            article_id: null,
            describeAnotherName: null,
            amount: null,
            office_ids: [],
          };

          this.showModal = false;
        } else {
          this.$store.dispatch('notifications/warning', {msg: 'Debe completar todos los campos obligatorios'}, {root: true});
        }
      });

    },
    removeProduct(item) {
      this.$confirm('¿Desea eliminar').then(confirm => {
        this.removeStoreProductService(item);
      }).catch(e => {

      });
    },
    filterArticle(data, cat_acquisition_type_id, product_or_service_id) {
      if (!data || !cat_acquisition_type_id) return [];
      /*if (cat_acquisition_type_id == 2 || cat_acquisition_type_id == 4) {
        return data;
      }
      if (!product_or_service_id) return [];
      return data = data.filter((item) => product_or_service_id == item.id);*/
      return data;

    },
    filterSelectedOffice(catOffice, office_ids) {

      if (!catOffice || !office_ids) return [];


      let array = [];
      array = _.intersectionWith(catOffice, office_ids,
          ({id}, item) => id == item
      );
      return array;
    },
    countCharacter(count) {
      if (!count) return 0;
      if (count != '') {
        let _count = count.toString().length;
        return _count
      }
    },
    async onCopy(e) {
      try {
        await this.$copyText(this.stripHtml(e.text)).then(async function (ee) {
          Notification.success('Se copió el texto correctamente.')
        }, function (e) {
          console.log(e)
        })
      } catch (e) {
        console.log("copy clipboard ", e)
      }
    },
    onError: function (e) {
      alert('Failed to copy the text to the clipboard')
      console.log(e);
    },
    stripHtml(html) {
      let tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    },
  },
  watch: {
    'requestForm.articles': {
      handler(after, before) {
        this.restartCalculation();
      },
      deep: true
    },
  },
}
</script>

<style>
.count-character {
  font-size: 10px;
  text-align: left !important;
  color: #606568;
}

.el-select-dropdown__item {
  max-width: 500px;
}

.el-tag.el-tag--info.el-tag--small {
  word-break: break-word !important;
  display: inline-table !important;
  white-space: unset !important;
}

.el-checkbox,
.el-checkbox__input {
  white-space: unset !important;
}

.el-checkbox__label {
  display: inline !important;
  word-break: break-word !important;
}


</style>